import Vue from 'vue'
import 'iview/dist/styles/iview.css';
// import 'view-design/dist/styles/iview.css';
// import './my-theme/dist/iview.css';
// import './styles/reset.less'
import {
    Button,
    Table,
    Message,
    Icon,
    Form,
    FormItem,
    Input,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Modal,
    Select,
    Cascader,
    Option,
    DatePicker,
    Spin,
    TimePicker,
    CheckboxGroup,
    Checkbox,
    Tree,
    Tooltip,
    RadioGroup,
    Radio,
    Tabs,
    TabPane,
    Switch,
    Upload,
    Transfer,
    Progress,
    Tag,
    InputNumber
} from 'view-design';
Vue.prototype.$Message = Message;
Vue.component('i-table', Table);
Vue.component('i-button', Button);
Vue.component('i-icon', Icon);
Vue.component('i-form', Form);
Vue.component('i-form-item', FormItem);
Vue.component('i-input', Input);
Vue.component('i-dropdown', Dropdown);
Vue.component('i-dropdownMenu', DropdownMenu);
Vue.component('i-dropdownItem', DropdownItem);
Vue.component('i-modal', Modal);
Vue.component('i-select', Select);
Vue.component('i-option', Option);
Vue.component('i-datepicker', DatePicker);
Vue.component('i-timePicker', TimePicker);
Vue.component('i-spin', Spin);
Vue.component('i-checkboxGroup', CheckboxGroup);
Vue.component('i-checkbox', Checkbox);
Vue.component('i-tree', Tree);
Vue.component('i-tooltip', Tooltip);
Vue.component('i-radioGroup', RadioGroup);
Vue.component('i-radio', Radio);
Vue.component('i-tabs', Tabs);
Vue.component('i-tab-pane', TabPane);
Vue.component('i-upload', Upload);
Vue.component('i-switch', Switch);
Vue.component('i-transfer', Transfer);
Vue.component('i-cascader', Cascader);
Vue.component('i-progress', Progress);
Vue.component('i-tag', Tag);
Vue.component('i-input-number', InputNumber);